<template>
  <!-- TODO: replace animation class -->

  <div
    class="sdv-activation-details"
    :style="rootStyle"
  >
    <slot name="header" />
    <slot
      name="body"
      :activation="activation"
      :context="context"
    >
      <ActivationSmartblockList
        :activation="activation"
        :context="context"
        @analytics="listeners.analytics"
      />
    </slot>
  </div>
</template>

<script lang="ts">
import { mdiClose } from '@mdi/js'
import { computed, defineComponent, PropType } from 'vue-demi'
import { ExperienceActivationContext, ExperienceActivationInstance } from 'sd-types/app/experience/activation'
import ActivationSmartblockList from './ActivationSmartblockList.vue'
import colorAlpha from 'color-alpha'
import { defineActivationListEmits, useBypassActivationListEvents } from '../composables/use-activation-list-events'

export default defineComponent({
  name: 'ActivationDetails',
  components: {
    ActivationSmartblockList
  },
  props: {
    activation: {
      type: Object as PropType<ExperienceActivationInstance>,
      required: true
    },
    context: {
      type: Object as PropType<ExperienceActivationContext>,
      required: false,
      default: () => ({})
    }
  },
  emits: {
    ...defineActivationListEmits()
  },
  setup (_props, context) {
    /**
     * This patches invalid use of opacity property in style object to generate rgba background
     * TODO: create an issue in Kurator to fix this
     * As a mitigation, we apply the style as is if background is already rgba
     * If not, we generate rgba background from background and opacity
     * Also, merging contentStyle and style because in current implementation there's no difference between the two
     */
    const rootStyle = computed(() => {
      const style = Object.assign({}, _props.activation.details?.contentStyle, _props.activation.details?.style)
      if (style.background == null || (typeof style.background === 'string' && !style.background.startsWith('rgba'))) {
        const { opacity, background, ...rest } = style
        return {
          ...rest,
          background: colorAlpha(background ?? 'black', opacity as number ?? 0.8)
        }
      }
      return style
    })

    const listeners = useBypassActivationListEvents(context)

    return {
      rootStyle,
      mdiClose,
      listeners
    }
  }
})
</script>
